import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const FAQHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>FAQ's</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default FAQHeader;
